import { useState } from "react";
import { Linkedin, Facebook, Mail, Link2, Check } from "lucide-react";

const X_ICON = (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

export default function ShareButtons({ title, suffix = "" }) {
    const [copied, setCopied] = useState(false);
    const url = typeof window !== "undefined" ? window.location.href : "";
    const u = encodeURIComponent(url);
    const t = encodeURIComponent(title);

    const links = [
        { id: "linkedin", label: "Share on LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`, icon: <Linkedin size={16} /> },
        { id: "facebook", label: "Share on Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, icon: <Facebook size={16} /> },
        { id: "x", label: "Share on X", href: `https://twitter.com/intent/tweet?url=${u}&text=${t}`, icon: X_ICON },
        { id: "email", label: "Share by email", href: `mailto:?subject=${t}&body=${t}%0A%0A${u}`, icon: <Mail size={16} /> },
    ];

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            window.prompt("Copy this link", url);
        }
    };

    const cls = "flex h-10 w-10 items-center justify-center rounded-full border border-border text-primary transition-colors hover:bg-primary hover:text-white";

    return (
        <div className="flex flex-wrap items-center gap-2" data-testid={`share-buttons${suffix}`}>
            <span className="mr-1 text-sm font-semibold text-muted-foreground">Share</span>
            {links.map((l) => (
                <a key={l.id} href={l.href} target={l.id === "email" ? undefined : "_blank"} rel="noopener noreferrer" aria-label={l.label} title={l.label} className={cls} data-testid={`share-${l.id}${suffix}`}>
                    {l.icon}
                </a>
            ))}
            <button onClick={copy} aria-label="Copy link" title="Copy link" className={cls} data-testid={`share-copy${suffix}`}>
                {copied ? <Check size={16} /> : <Link2 size={16} />}
            </button>
            {copied && <span className="text-sm text-primary" data-testid={`share-copied${suffix}`}>Link copied</span>}
        </div>
    );
}
